import { colors } from '@mui/material';
import tinycolor from 'tinycolor2';
import palette from '@gobo/gobo.react/lib/styles/theme/palette';

const BASE_COLOR_OBJECT = tinycolor({
  r: 0,
  g: 74,
  b: 81,
});

const PAPER_COLOR = BASE_COLOR_OBJECT.clone().lighten(75).toHexString();

const BACKGROUND_COLOR = BASE_COLOR_OBJECT.clone().lighten(80).toHexString();

export default {
  background: {
    paper: PAPER_COLOR,
    default: BACKGROUND_COLOR,
  },
  DataGrid: {
    bg: PAPER_COLOR,
  },
  TableCell: {
    border: palette.divider,
  },
  chart: {
    'light-green': colors.green[200],
    green: colors.green[500],
    'dark-green': colors.green[700],
    'light-lime': colors.lime[200],
    lime: colors.lime[500],
    'dark-lime': colors.lime[700],
    'light-yellow': colors.yellow[200],
    yellow: colors.yellow[500],
    'dark-yellow': colors.yellow[700],
    'light-orange': colors.orange[200],
    orange: colors.orange[500],
    'dark-orange': colors.orange[700],
    'light-teal': colors.teal[100],
    teal: colors.teal[400],
    'dark-teal': colors.teal[700],
    'light-purple': colors.purple[100],
    purple: colors.purple[400],
    'dark-purple': colors.purple[700],
    'light-blue': colors.blue[100],
    blue: colors.blue[400],
    'dark-blue': colors.blue[700],
    'light-red': colors.red[200],
    red: colors.red[500],
    'dark-red': colors.red[700],
    white: '#fff',
  },
};
